import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import {
    BaseResponse, AbsenceRequestResponse,
    AbsenceCauseResponse, Absence, AbsenceResponse,
    WorkedDaysResponse, DateUserAbsenceResponse, YearsResponse,
    AbsenceRequestCountResponse, HolidayReportResponse,
    CaptchaResponse,
    AbsenceInsertionMalattiaResponse
} from '../core/core.component';
import { Http, Headers, URLSearchParams, RequestOptions, ResponseContentType } from '@angular/http';
import { AppConstants } from '../core/app.constants';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AssenzeService {
    private pattern: string = "yyyy-MM-dd";

    constructor(private http: Http, private datePipe: DatePipe) { }

    assenzeDetailStatus: Subject<any> = new Subject();
    assenzeMalattiaDetailStatus: Subject<any> = new Subject();
    refreshEvent: Subject<any> = new Subject();

    getAssenzeMalattiaDetailStatus(): Observable<any> {
        return this.assenzeMalattiaDetailStatus.asObservable();
    }

    getAssenzeDetailStatus(): Observable<any> {
        return this.assenzeDetailStatus.asObservable();
    }

    getRefreshEvent(): Observable<string> {
        return this.refreshEvent.asObservable();
    }

    openAssenzeDetail(date?: Date) {
        let data = date != null && typeof (date) != 'undefined' ? date : null;
        this.assenzeDetailStatus.next({ status: "open", date: data });
    }

    closeAssenzeDetail() {
        this.assenzeDetailStatus.next({ status: "close" });
    }

    openAssenzeMalattiaDetail() {
        this.assenzeMalattiaDetailStatus.next({ status: "open" });
    }

    closeAssenzeMalattiaDetail() {
        this.assenzeMalattiaDetailStatus.next({ status: "close" });
    }

    fireRefreshEvent() {
        this.refreshEvent.next();
    }

    getRequests(srmToken, userIds: string, stato: string, requestDateFrom: Date): Observable<AbsenceRequestResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/requests";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        if (userIds != null) {
            params.append("userIDs", userIds);
        }
        if (stato != null) {
            params.append("stato", stato);
        }
        if (requestDateFrom != null) {
            params.append("requestDateFrom", this.datePipe.transform(requestDateFrom, this.pattern));
        }
        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    getRequestsCount(srmToken, userIds: string, stato: string, requestDateFrom: Date): Observable<AbsenceRequestCountResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/requestsCount";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        if (userIds != null) {
            params.append("userIDs", userIds);
        }
        if (stato != null) {
            params.append("stato", stato);
        }
        if (requestDateFrom != null) {
            params.append("requestDateFrom", this.datePipe.transform(requestDateFrom, this.pattern));
        }
        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    getAbsenceCauses(srmToken): Observable<AbsenceCauseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/causes";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }

    getWorkedDays(srmToken, dateFrom: Date, dateTo: Date): Observable<WorkedDaysResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/workeddays";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();

        if (dateFrom != null) {
            params.append("dateFrom", this.datePipe.transform(dateFrom, this.pattern));
        }
        if (dateTo != null) {
            params.append("dateTo", this.datePipe.transform(dateTo, this.pattern));
        }
        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    getWorkedDaysMonthly(srmToken, month: number, year: number): Observable<WorkedDaysResponse> {
        // primo giorno del mese
        let dataFrom = new Date();
        dataFrom.setFullYear(year, month, 1);

        // ultimo giorno del mese
        let dataTo = new Date();
        dataTo.setFullYear(year, month + 1, 0);
        return this.getWorkedDays(srmToken, dataFrom, dataTo);
    }

    approve(srmToken, requestId: number): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/request/" + requestId + "/approve";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.put(url, {}, { headers: headers }).map((responseData) => responseData.json());
    }

    insertRequest(srmToken, dateBegin: Date, dateEnd: Date, causeId: number, typeDay: string): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/request";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            dateBegin: this.datePipe.transform(dateBegin, this.pattern),
            dateEnd: this.datePipe.transform(dateEnd, this.pattern),
            causeId: causeId,
            typeDay: typeDay
        };

        return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    updateRequest(srmToken, requestId: number, dateBegin: Date, dateEnd: Date, causeId: number, typeDay: string): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/request/" + requestId;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            dateBegin: this.datePipe.transform(dateBegin, this.pattern),
            dateEnd: this.datePipe.transform(dateEnd, this.pattern),
            causeId: causeId,
            typeDay: typeDay
        };

        return this.http.put(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    deleteRequest(srmToken, requestId: number): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/request/" + requestId;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
    }

    insertAssenze(srmToken, userId: number, dateBegin: Date, dateEnd: Date, causeId: number, hours: number): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            dateBegin: this.datePipe.transform(dateBegin, this.pattern),
            dateEnd: this.datePipe.transform(dateEnd, this.pattern),
            causeId: causeId,
            userId: userId,
            hours: hours
        };

        return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    getAssenze(srmToken, month: number, year: number, userIds?: number[]): Observable<AbsenceResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        // primo giorno del mese
        let dataFrom = new Date();
        dataFrom.setFullYear(year, month, 1);

        // ultimo giorno del mese
        let dataTo = new Date();
        dataTo.setFullYear(year, month + 1, 0);

        let ids: string = '';
        if (userIds) {
            userIds.forEach(id => {
                ids += id + ',';
            });
            ids = ids.substr(0, ids.length - 1);
        }

        let query = {
            from: this.datePipe.transform(dataFrom, this.pattern),
            to: this.datePipe.transform(dataTo, this.pattern),
            userIds: ids
        };

        return this.http.get(url, { search: query, headers: headers }).map((responseData) => responseData.json());
    }

    deleteAssenza(srmToken, date: Date, userId: number): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/" + this.datePipe.transform(date, this.pattern) + "/" + userId;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
    }

    updateAssenza(srmToken, absence: Absence): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = {
            date: this.datePipe.transform(absence.date, this.pattern),
            causeId: absence.causeId,
            userId: absence.userId,
            hours: absence.hoursNumber
        };
        return this.http.put(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    findOverlappingAbsences(srmToken, idRequest: number, dateFrom: Date, dateTo: Date): Observable<DateUserAbsenceResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/overlaps";
        url = AppConstants.urlForNoCache(url);

        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let query = {
            dateFrom: this.datePipe.transform(dateFrom, this.pattern),
            dateTo: this.datePipe.transform(dateTo, this.pattern),
        };
        if (idRequest) {
            query['idRequest'] = idRequest;
        }
        return this.http.get(url, { search: query, headers: headers }).map((responseData) => responseData.json());
    }

    getDistinctYears(srmToken): Observable<YearsResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/years";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
    }

    refuse(srmToken, idRequest: number, subject: string, message: string): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/absence/request/" + idRequest + "/refuse";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let body = AppConstants.formUrlEncode({ 'message': message, 'subject': subject });
        return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    getHolidayReport(srmToken, includeInactiveUsers: boolean, year?: number): Observable<HolidayReportResponse> {
        let url = environment.REST_SERVICE_BASE_URL + '/absence/report';
        url = AppConstants.urlForNoCache(url);
        const headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        const params = year ? {
            includeInactiveUsers: includeInactiveUsers,
            year: year
        } : {
            includeInactiveUsers: includeInactiveUsers,
        };
        const body = params.toString();
        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }


    inserisciAssenzaPerMalattia(srmToken: string, numCertificato: string, idUtente: number, captcha: string, inserimento: boolean): Observable<AbsenceInsertionMalattiaResponse> {
        let url = environment.REST_SERVICE_BASE_URL + "/absence/inserisciAssenzaPerMalattia";
        url = AppConstants.urlForNoCache(url);

        const headers: Headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        const options: RequestOptions = new RequestOptions({
            headers: headers,
            responseType: ResponseContentType.Json
        });

        const body = {
            numCertificato: numCertificato,
            idUtente: idUtente,
            captcha: captcha,
            inserimento: inserimento
        };

        console.log(url);

        return this.http.post(url, body, options).map((responseData) => responseData.json());

    }
}


// WEBPACK FOOTER //
// ./src/app/service/assenze.service.ts